var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3405 0C6.4605 0 0.863281 5.59774 0.863281 12.4772C0.863281 19.3567 6.4605 24.9545 13.3405 24.9545C20.2205 24.9545 25.8178 19.3573 25.8178 12.4772C25.818 5.59722 20.2205 0 13.3405 0ZM20.2892 16.342C20.4514 16.5042 20.4514 16.768 20.2892 16.9302L17.7939 19.4256C17.7124 19.5071 17.6059 19.548 17.4994 19.548C17.3929 19.548 17.2864 19.5073 17.2049 19.4266C15.0708 17.292 11.61 17.2914 9.47565 19.4258C9.31343 19.588 9.04968 19.588 8.88745 19.4258L6.39211 16.9304C6.22989 16.7682 6.22989 16.5044 6.39211 16.3422C8.52652 14.2078 8.52652 10.7472 6.39211 8.61284C6.22989 8.45062 6.22989 8.18687 6.39211 8.02464L8.88745 5.5293C9.04967 5.36708 9.31342 5.36708 9.47565 5.5293C11.6101 7.66371 15.0706 7.66371 17.205 5.5293C17.3672 5.36708 17.631 5.36708 17.7932 5.5293L20.2886 8.02464C20.4508 8.18686 20.4508 8.45061 20.2886 8.61284C18.1542 10.7472 18.1547 14.2079 20.2892 16.342Z",
    fill: "#ED0707"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.f40fec19db97503be5817b2568512687.svg";
export { ForwardRef as ReactComponent };